import { render, staticRenderFns } from "./PuzzleTermList.vue?vue&type=template&id=84454210"
import script from "./PuzzleTermList.vue?vue&type=script&lang=js"
export * from "./PuzzleTermList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports